import React from 'react'
import { Button, Table } from 'react-bootstrap'

const currency = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })

const HIDDEN = 'd-none d-md-table-cell'

function InvestmentTable({ records, activeView, emptyMessage, onRecordSale, onDelete }) {
  return (
    <div className="table-responsive">
      <Table hover size="sm">
        <thead>
          <tr>
            <th className={HIDDEN}>Account</th>
            <th>Symbol</th>
            <th className={HIDDEN}>Type</th>
            <th>Date</th>
            <th>Qty</th>
            <th className={HIDDEN}>Buy Price</th>
            <th className={HIDDEN}>Cost Basis</th>
            <th className={HIDDEN}>Sale Date</th>
            <th className={HIDDEN}>Sale Qty</th>
            <th className={HIDDEN}>Sale Price</th>
            <th className={HIDDEN}>Gain/Loss</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {records.length === 0 ? (
            <tr>
              <td colSpan={12}>{emptyMessage}</td>
            </tr>
          ) : (
            records.map((inv) => {
              const costBasis = inv.quantity * inv.purchase_price
              const gainLoss =
                inv.sale_price != null
                  ? (inv.sale_price * inv.sale_quantity) - (inv.purchase_price * inv.quantity)
                  : null

              return (
                <tr key={`${inv.id}-${inv.purchase_date}`}>
                  <td className={HIDDEN}>{inv.account}</td>
                  <td>{inv.symbol}</td>
                  <td className={HIDDEN}>{inv.account_type}</td>
                  <td>{inv.purchase_date}</td>
                  <td>{inv.quantity}</td>
                  <td className={HIDDEN}>{currency.format(inv.purchase_price)}</td>
                  <td className={HIDDEN}>{currency.format(costBasis)}</td>
                  <td className={HIDDEN}>{inv.sale_date ?? '—'}</td>
                  <td className={HIDDEN}>{inv.sale_quantity ?? '—'}</td>
                  <td className={HIDDEN}>{inv.sale_price != null ? currency.format(inv.sale_price) : '—'}</td>
                  <td
                    className={
                      gainLoss == null
                        ? HIDDEN
                        : `${HIDDEN} ${gainLoss >= 0 ? 'text-success' : 'text-danger'}`
                    }
                  >
                    {gainLoss != null ? currency.format(gainLoss) : '—'}
                  </td>
                  <td>
                    {activeView === 'open' && (
                      <Button
                        size="sm"
                        variant="outline-primary"
                        className="me-1"
                        onClick={() => onRecordSale(inv)}
                      >
                        Record Sale
                      </Button>
                    )}
                    <Button
                      size="sm"
                      variant="outline-danger"
                      onClick={() => onDelete(inv)}
                    >
                      Delete
                    </Button>
                  </td>
                </tr>
              )
            })
          )}
        </tbody>
      </Table>
    </div>
  )
}

export default InvestmentTable
